import {useRef, useEffect} from 'react'
import Artwork from './intro-hero-webgl/artwork'
import Common from './intro-hero-webgl/common'
import Assets from './intro-hero-webgl/assets'

const COPY = {
  webgl: {
    alt: 'Mona the Octocat, Copilot, and Ducky float jubilantly upward from behind the GitHub product demo accompanied by a purple glow and a scattering of stars.',
  },
}

export function IntroHero({
  setCopyScrollOpacity,
  setCopyScrollScale,
  startCopyAnimation,
}: {
  setCopyScrollOpacity: (o: number) => void
  setCopyScrollScale: (o: number) => void
  startCopyAnimation: () => void
}) {
  const wrapperRef = useRef<HTMLDivElement>(null)
  const canvasRef = useRef<HTMLCanvasElement>(null)
  const animationFrameId = useRef(0)

  useEffect(() => {
    let isClosed = false
    let isReducedMotion = false
    const handleReduceMotionChange = (event: MediaQueryListEvent) => {
      isReducedMotion = event.matches

      if (isReducedMotion) {
        setCopyScrollScale(1)
        setCopyScrollOpacity(1)
        if (artwork) artwork.renderOnce()
      } else {
        tick()
      }
    }

    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)')
    mediaQuery.addEventListener('change', handleReduceMotionChange)
    isReducedMotion = mediaQuery.matches

    const common = new Common({isReduceMotion: isReducedMotion})
    common.startCopyAnimation = startCopyAnimation
    const assets = new Assets()
    const artwork = new Artwork(wrapperRef.current!, canvasRef.current!, common, assets)
    const resizeFunc = () => {
      const width = wrapperRef.current?.clientWidth || 0
      const windowWidth = document.body.clientWidth
      if (wrapperRef.current) {
        wrapperRef.current.style.left = `${Math.round(windowWidth * 0.5 - width * 0.5)}px`
      }
      artwork.resize()

      if (isReducedMotion) {
        artwork.renderOnce()
      }
    }
    resizeFunc()

    // eslint-disable-next-line github/prefer-observers
    window.addEventListener('resize', resizeFunc)
    const scrollFunc = () => {
      artwork.scroll()
    }

    // eslint-disable-next-line github/prefer-observers
    window.addEventListener('scroll', scrollFunc)

    assets.load(() => {
      if (!isClosed) {
        artwork.init()
        if (isReducedMotion) {
          artwork.renderOnce()
        }
      }
    })
    const tick = () => {
      if (!isReducedMotion) {
        artwork.update()

        if (common.isMobile) {
          setCopyScrollScale(1)
          setCopyScrollOpacity(1)
        } else {
          const scale = 1.0 - artwork.copyProgress.current * 0.1
          setCopyScrollScale(scale)

          const opacity = 1.0 - artwork.copyProgress.current
          setCopyScrollOpacity(opacity)
        }

        animationFrameId.current = requestAnimationFrame(tick)
      }
    }

    if (!isReducedMotion) {
      tick()
    }

    return () => {
      if (animationFrameId.current) {
        cancelAnimationFrame(animationFrameId.current)
      }
      isClosed = true
      window.removeEventListener('resize', resizeFunc)
      window.removeEventListener('scroll', scrollFunc)
      mediaQuery.removeEventListener('change', handleReduceMotionChange)
    }
    // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="lp-IntroVisuals">
      <div className="lp-IntroVisuals-canvasWrapper" ref={wrapperRef}>
        <canvas className="lp-IntroVisuals-canvas" ref={canvasRef} />
      </div>
      <div className="sr-only">{COPY.webgl.alt}</div>
    </div>
  )
}

try{ IntroHero.displayName ||= 'IntroHero' } catch {}